var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multi-factor-authentication-q-r-code')
}
var staticRenderFns = []

export { render, staticRenderFns }